const ChatSidePanelResizer = <template>
  <div class="chat-side-panel-resizer"></div>
</template>;

export default ChatSidePanelResizer;
